import { Auth } from 'aws-amplify'
import LogIn from 'components/auth/LogIn'
import { DataContext } from 'contexts/DataContextContainer'
import detectBrowserLanguage from 'detect-browser-language'
import PageLayout from 'layouts'
import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Route } from 'react-router-dom'
import axiosClient, { setAuthHeader } from 'services/axios-client'
import { AVAILABLE_LANGUAGES } from 'services/constants'

// TODO: Put a bunch of this into auth provider.
const RouteWrapper = ({ component: Component, isPublic = false, ...rest }) => {
  const { authUser, setAuthUser, setLoggedInUser, setIsCheckingLogin } =
    useContext(DataContext)
  const { i18n } = useTranslation()

  useEffect(() => {
    const storedLang = localStorage.getItem('locale')
    if (!storedLang) {
      let userLang = detectBrowserLanguage().substring(0, 2).toLowerCase()

      if (!AVAILABLE_LANGUAGES.includes(userLang)) userLang = 'en'

      i18n.changeLanguage(userLang)

      localStorage.setItem('locale', userLang)
    } else {
      i18n.changeLanguage(storedLang)
    }

    if (!authUser) {
      console.log('In route wrapper')
      const checkAuth = async () => {
        let cogUser
        try {
          cogUser = await Auth.currentAuthenticatedUser()
        } catch (err) {
          console.error('Unable to get authenticated user:', err)
          // TODO: Refactor how we do this because it's spaghetti
          setIsCheckingLogin(false)
        }

        if (!cogUser) {
          console.log('No cog user found')
          setAuthUser(null)
          setLoggedInUser(null)
        } else {
          const session = await Auth.currentSession()
          const idToken = session.getIdToken()

          console.log('posting for token')
          const { data } = await axiosClient.post('/user/token', {
            cognitoID: idToken.payload.sub,
            cognitoToken: session.getAccessToken().getJwtToken(),
          })
          const { token } = data
          setAuthHeader(token)

          const email = idToken.payload.email
          console.log('getting user')
          // We don't have a user created with the oauth email. We need to look at this in the user creation.
          await axiosClient
            .get(`/users?cognito_id=${idToken.payload.sub}`)
            .then(({ data }) => {
              setLoggedInUser(data)
              setIsCheckingLogin(false)
            })

          setAuthUser(
            // TODO: Sort out the scopes to get the proper name and replace this hack.
            cogUser?.attributes ? cogUser?.attributes : { given_name: email },
          )
        }
      }
      checkAuth()
    } else {
      setIsCheckingLogin(false)
    }
  }, [authUser, i18n, setAuthUser, setLoggedInUser, setIsCheckingLogin])

  return (
    <Route
      {...rest}
      render={(props) => {
        const _props = { ...rest, ...props }

        return (
          <>
            {isPublic ? (
              <>
                {Component === LogIn ? (
                  <Component {..._props} />
                ) : (
                  <PageLayout>
                    <Component {..._props} />
                  </PageLayout>
                )}
              </>
            ) : (
              <>
                {authUser ? (
                  <PageLayout>
                    <Component {..._props} />
                  </PageLayout>
                ) : (
                  <LogIn />
                )}
              </>
            )}
          </>
        )
      }}
    />
  )
}

export default RouteWrapper
